import { render, staticRenderFns } from "./TkAccordion.vue?vue&type=template&id=7ca75338&"
import script from "./TkAccordion.vue?vue&type=script&lang=js&"
export * from "./TkAccordion.vue?vue&type=script&lang=js&"
import style0 from "./TkAccordion.vue?vue&type=style&index=0&id=7ca75338&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports